import request from "utils/request";
import moment from "moment";

import { baseRequestURL, constructQueryParams } from "api/BaseAPI";

export function getProjects(folderId, next, latestId) {
  const queryArr = [next ? "order_by=id&reverse=1&next=" + next : "", latestId ? "id=" + latestId : ""];
  let queryUrl = "";
  if (folderId || folderId === 0) {
    queryUrl = baseRequestURL + "v1/folders/" + folderId + "/projects" + constructQueryParams(queryArr);
  } else {
    queryUrl = baseRequestURL + "v1/projects" + constructQueryParams(queryArr);
  }
  return request(queryUrl, {
    method: "GET"
  }).then((response) => response);
}

export function getProject(id) {
  return request(baseRequestURL + "v1/projects/" + id, {
    method: "GET"
  }).then((response) => response);
}

export function createProject(project) {
  return request(baseRequestURL + "v1/projects/", {
    method: "POST",
    body: JSON.stringify({ ...project })
  }).then((response) => response);
}

export function updateProject(id, project) {
  return request(baseRequestURL + "v1/projects/" + id, {
    method: "PATCH",
    body: JSON.stringify({ ...project })
  }).then((response) => response);
}

export function deleteProject(id) {
  return request(baseRequestURL + "v1/projects/" + id, {
    method: "DELETE"
  }).then((response) => response);
}

export function deleteProjectRole(id) {
  return request(baseRequestURL + "v1/project_roles/" + id, {
    method: "DELETE"
  }).then((response) => response);
}

export function deployProject(id) {
  return request(baseRequestURL + "v1/projects/" + id + "/deploy", {
    method: "POST",
    body: JSON.stringify({})
  }).then((response) => response);
}

export function getScenarios(id) {
  return request(baseRequestURL + "v1/projects/" + id + "/scenarios", {
    method: "GET"
  }).then((response) => response);
}

export function createScenario(id, scenario) {
  return request(baseRequestURL + "v1/projects/" + id + "/scenarios", {
    method: "POST",
    body: JSON.stringify({ ...scenario })
  }).then((response) => response);
}

export function patchScenario(scenarioId, scenario) {
  return request(baseRequestURL + "v1/project_scenarios/" + scenarioId, {
    method: "PATCH",
    body: JSON.stringify({ ...scenario })
  }).then((response) => response);
}

export function addScenarioSegmentAssumption(scenarioId, segmentId, assumption) {
  return request(baseRequestURL + "v1/project_scenario/" + scenarioId + "/segments/" + segmentId + "/assumptions", {
    method: "POST",
    body: JSON.stringify(assumption)
  }).then((response) => response);
}

export function deleteScenario(scenarioId) {
  return request(baseRequestURL + "v1/project_scenarios/" + scenarioId, {
    method: "DELETE"
  }).then((response) => response);
}

export function createProjectMonitor(projectId, projectMonitor) {
  return request(baseRequestURL + "v1/projects/" + projectId + "/monitors", {
    method: "POST",
    body: JSON.stringify({ ...projectMonitor })
  }).then((response) => response);
}

export function getProjectMonitors(projectId) {
  const url =
    projectId === undefined
      ? `${baseRequestURL}v1/project_monitors/`
      : `${baseRequestURL}v1/projects/${projectId}/monitors`;

  return request(url, {
    method: "GET"
  }).then((response) => response);
}

export function getProjectMonitor(projectMonitorId) {
  return request(baseRequestURL + "v1/project_monitors/" + projectMonitorId, {
    method: "GET"
  }).then((response) => response);
}

export function updateProjectMonitor(projectMonitor) {
  const update = {};

  if (projectMonitor.unique_id_name !== undefined) {
    update.unique_id_name = projectMonitor.unique_id_name;
  }

  if (projectMonitor.terminal_conditions !== undefined) {
    update.terminal_conditions = projectMonitor.terminal_conditions;
  }

  if (projectMonitor.business_prediction_name !== undefined) {
    update.business_prediction_name = projectMonitor.business_prediction_name;
  }

  if (projectMonitor.activity_conditions !== undefined) {
    update.activity_conditions = projectMonitor.activity_conditions;
  }

  return request(baseRequestURL + "v1/project_monitors/" + projectMonitor.id, {
    method: "PATCH",
    body: JSON.stringify(update)
  }).then((response) => response);
}

export function deleteProjectMonitor(projectMonitorId) {
  return request(baseRequestURL + "v1/project_monitors/" + projectMonitorId, {
    method: "DELETE"
  }).then((response) => response);
}

export function getAssumption(id, assumptionId) {
  return request(baseRequestURL + "v1/projects/" + id + "/project_segment_assumptions/" + assumptionId, {
    method: "GET"
  }).then((response) => response);
}

export function getProjectSegments(id) {
  return request(baseRequestURL + "v1/projects/" + id + "/segments", {
    method: "GET"
  }).then((response) => response);
}

export function createProjectSegment(id, segment) {
  return request(baseRequestURL + "v1/projects/" + id + "/segments", {
    method: "POST",
    body: JSON.stringify({ ...segment })
  }).then((response) => response);
}

export function patchProjectSegment(segmentId, segment) {
  return request(baseRequestURL + "v1/project_segments/" + segmentId, {
    method: "PATCH",
    body: JSON.stringify({ ...segment })
  }).then((response) => response);
}

export function createSegmentJob(segmentId, job) {
  return request(baseRequestURL + "v1/project_segments/" + segmentId + "/jobs", {
    method: "POST",
    body: JSON.stringify({ ...job })
  }).then((response) => response);
}

export function patchSegmentJob(segmentJobId, segmentJob) {
  return request(baseRequestURL + "v1/project_segment_jobs/" + segmentJobId, {
    method: "PATCH",
    body: JSON.stringify({ ...segmentJob })
  }).then((response) => response);
}

export function addUserRoleToSegment(segmentId, userId, role) {
  return request(baseRequestURL + "v1/project_segments/" + segmentId + "/roles", {
    method: "POST",
    body: JSON.stringify({
      role_user: userId,
      role_type: role
    })
  }).then((response) => response);
}

export function deleteUserRoleFromSegment(segmentRoleId) {
  return request(baseRequestURL + "v1/project_segment_roles/" + segmentRoleId, {
    method: "DELETE"
  }).then((response) => response);
}

export function patchUserRoleSegment(segmentRoleId, role) {
  return request(baseRequestURL + "v1/project_segment_roles/" + segmentRoleId, {
    method: "PATCH",
    body: JSON.stringify({
      role_type: role
    })
  }).then((response) => response);
}

export function patchUserRoleSegmentFeedback(segmentRoleId, feedback) {
  return request(baseRequestURL + "v1/project_segment_roles/" + segmentRoleId, {
    method: "PATCH",
    body: JSON.stringify({
      preferences: {
        feedback: feedback
      }
    })
  }).then((response) => response);
}

export function submitUserFeedback(segmentId, feedback) {
  return request(baseRequestURL + "v1/project_segments/" + segmentId + "/feedback", {
    method: "POST",
    body: JSON.stringify(feedback)
  }).then((response) => response);
}

export function submitScenarioFeedback(assumptionId, feedback) {
  return request(baseRequestURL + "v1/project_segment_assumptions/" + assumptionId + "/ratings", {
    method: "POST",
    body: JSON.stringify(feedback)
  }).then((response) => response);
}

export function getScenarioFeedback(assumptionId) {
  return request(baseRequestURL + "v1/project_segment_assumptions/" + assumptionId + "/ratings", {
    method: "GET"
  }).then((response) => response);
}

export function submitScenarioComment(assumptionId, comment) {
  return request(baseRequestURL + "v1/project_segment_assumptions/" + assumptionId + "/comments", {
    method: "POST",
    body: JSON.stringify(comment)
  }).then((response) => response);
}

export function getScenarioComments(assumptionId) {
  return request(baseRequestURL + "v1/project_segment_assumptions/" + assumptionId + "/comments", {
    method: "GET"
  }).then((response) => response);
}

export function patchUserRoleSegmentPercent(segmentRoleId, percentProcessed) {
  return request(baseRequestURL + "v1/project_segment_roles/" + segmentRoleId, {
    method: "PATCH",
    body: JSON.stringify({
      preferences: {
        percent_processed: percentProcessed
      }
    })
  }).then((response) => response);
}

export function createAssumption(segmentId, setup) {
  return request(baseRequestURL + "v1/project_segments/" + segmentId + "/assumptions", {
    method: "POST",
    body: JSON.stringify({
      data: setup,
      status: "DRAFT"
    })
  }).then((response) => response);
}

export function createJob(segmentId, jobId, status = "DRAFT") {
  return request(baseRequestURL + "v1/project_segments/" + segmentId + "/jobs", {
    method: "POST",
    body: JSON.stringify({
      job_id: jobId,
      status: status
    })
  }).then((response) => response);
}

export function approveAssumption(assumptionId) {
  const startTime = moment();

  return updateAssumptionStatus(assumptionId, "ACCEPTED").then((assumption) => {
    if (assumption && assumption.updated_date) {
      const updated = moment.utc(assumption.updated_date);

      if (startTime.isAfter(updated)) {
        // we need to force this to be the most recent approved assumption
        return updateAssumptionStatus(assumptionId, "PENDING").then(() =>
          updateAssumptionStatus(assumptionId, "ACCEPTED")
        );
      }
    }

    return Promise.resolve(assumption);
  });
}

export function updateAssumptionStatus(assumptionId, status) {
  return request(baseRequestURL + "v1/project_segment_assumptions/" + assumptionId, {
    method: "PATCH",
    body: JSON.stringify({
      status: status
    })
  }).then((response) => response);
}

export function updateAssumption(assumptionId, update) {
  return request(baseRequestURL + "v1/project_segment_assumptions/" + assumptionId, {
    method: "PATCH",
    body: JSON.stringify(update)
  }).then((response) => response);
}

export function deleteAssumption(assumptionId) {
  return request(baseRequestURL + "v1/project_segment_assumptions/" + assumptionId, {
    method: "DELETE"
  }).then((response) => response);
}
